import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import DashboardLayout from "../../../components/ui/DashboardLayout";
import Loading from "../../../components/ui/Loading";
import { LoaderIcon } from "../../../components/ui/Swicons";
import { devURL } from "../../../utils";
import RecipientItem from "./RecipentItem";

export default function RecipientList() {
  const token = localStorage.getItem("swToken");
  const [recipientData, setRecipientData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [recipientId, setRecipientId] = useState();
  const [dataListData, setDataListData] = useState([]);
  const [disablePage, setDisablePage] = useState(false);
  const [rec_name, setRec_name] = useState("");
  const [paginatePages, setPaginatePages] = useState([]);
  const [loader, isLoading] = useState(false);
  const [datalistId, setDatalistId] = useState("list");
  const navigate = useNavigate();

  useEffect(() => {
    getRecipientsData();
  }, [page]);

  useEffect(() => {
    getAllRecipientsData();
  }, []);

  const getAllRecipientsData = () => {
    axios
      .get(`${devURL}/recipient/all`, {
        headers: { token: token },
      })
      .then((res) => {
        setDataListData(res.data);
        let reSultDisc = {};
        res.data.map(
          (recipient, index) =>
            (reSultDisc[recipient._id] =
              recipient.recipient_name +
              " (" +
              recipient.recipient_nick_name +
              ")")
        );
        let names = {};
        res.data.map(
          (recipient, index) =>
            (names[recipient.recipient_name] = recipient._id)
        );
        setRec_name(names);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          toast.error("Session expired please login again");
          localStorage.removeItem("swToken");
          navigate("/Login");
        }
        console.log(err);
      });
  };

  const getRecipientsData = () => {
    isLoading(true);
    axios
      .get(`${devURL}/recipient/get?page=` + page, {
        headers: { token: token },
      })
      .then((res) => {
        if (res.data.status) {
          setRecipientData(res.data.recipients);
          setTotalPage(res.data.pages);
          let pageArray = [];
          for (let i = 1; i <= res.data.pages; i++) {
            pageArray.push(i);
          }
          setPaginatePages(pageArray);
          if (res.data.recipients.length > 0) {
            isLoading(false);
          }
        }
      })
      .catch((err) => {
        isLoading(false);
        if (err.response.status === 401) {
          localStorage.removeItem("swToken");
          toast.error("Session expired please login again");
          return navigate("/Login");
        }
        console.log(err);
      });
  };

  const _deleteRecipient = (recipient_id) => {
    swal({
      title: "Delete Recipient?",
      text: "Do you really want to delete recipient?",
      icon: "warning",
      type: "warning",
      buttons: {
        cancel: "No",
        yes: "Yes",
      },
    }).then((value) => {
      if (value === "yes") {
        isLoading(true);
        axios
          .post(
            `${devURL}/recipient/delete`,
            { id: recipient_id },
            { headers: { token: token } }
          )
          .then((res) => {
             ;
            if (res.data.status) {
              isLoading(false);
              toast.success("You have successfully deleted recipient!");
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            isLoading(false);
            getRecipientsData();
          });
      }
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleSearchChange = (e) => {
    setRecipientId(rec_name[e.target.value]);
    setDatalistId("list");
  };

  const getSearchRecipient = () => {
    var filteredRecipients = dataListData.filter(recipient => recipient._id === recipientId);
    setRecipientData(filteredRecipients);
    setDisablePage(true);
  };

  const handleFocus = () => {
    setDatalistId("");
  };
  return (
    <DashboardLayout>
      {loader ? (
        <Loading />
      ) : (
        <div>
          <div className="page-title text-xl font-bold gap-8 lg:flex justify-center ">
            <p className="lg:mr-6 lg:mt-1">Recipient List</p>
            <Link to="/Add-Recipient">
              <button
                type="submit"
                className="group relative mt-4 lg:mt-0 py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover"
              >
                Add Recipient{" "}
              </button>{" "}
            </Link>
            <div className="lg:float-right">
              <form onSubmit={handleSubmit}>
                <div class="flex justify-center">
                  <div class="mb-3 w-full mt-6 lg:mt-0 xl:w-96">
                    <div class="relative flex justify-center align-middle items-stretch w-full mb-4">
                      <input
                        type="search"
                        class="form-control relative w-3/5 lg:w-4/5 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        placeholder="Enter recipient name"
                        onChange={handleSearchChange}
                        onFocus={handleFocus}
                        list="list"
                      />
                      <button
                        class="btn px-6 py-2.5 bg-themeColor text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-themeHover hover:shadow-lg focus:bg-blue-700  focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out flex items-center"
                        type="button"
                        id="button-addon2"
                        onClick={() => getSearchRecipient()}
                      >
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="search"
                          class="w-4"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="currentColor"
                            d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <datalist id={datalistId}>
                  {dataListData.length > 0 && (
                    <>
                      {dataListData.map((recipient, index) => {
                        if (!recipient.is_deleted) {
                          return (
                            <option
                              className="py-2"
                              value={recipient.recipient_name}
                              key={recipient._id}
                            >
                              ({recipient.recipient_nick_name})
                            </option>
                          );
                        }
                      })}
                    </>
                  )}
                </datalist>
              </form>
            </div>
          </div>
          <div className="ml-8 lg:ml-0 mt-8 lg:mr-6 ">
            <table className="table-fixed w-[90%] lg:w-3/4 mx-auto">
              <thead className="border-b">
                <tr>
                  <th className="text-gray-400 py-5 text-xs lg:text-sm text-left">
                    Name
                  </th>
                  <th className="text-gray-400 py-5 text-xs lg:text-sm">
                    Account Number
                  </th>
                  <th className="text-gray-400 py-5 text-xs lg:text-sm">
                    Status
                  </th>
                  <th className="text-gray-400 py-5 text-xs lg:text-sm">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {recipientData.length > 0 && (
                  <>
                    {recipientData.map((recipient, index) => {
                      if (!recipient.is_deleted) {
                        return (
                          <RecipientItem
                            recipient={recipient}
                            _deleteRecipient={_deleteRecipient}
                          />
                        );
                      }
                    })}
                  </>
                )}

                {!loader && recipientData.length === 0 && (
                  <tr>
                    <td
                      colSpan="9"
                      className="py-6 text-sm text-center sw-cancelled"
                    >
                      No recipients record were found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {disablePage ? (
              <></>
            ) : (
              <div className="sw-pagination text-center mt-6">
                <ul>
                  {paginatePages.map((value) => (
                    <li
                      className={page == value ? "sw-active" : ""}
                      onClick={() => setPage(value)}
                      key={"pagination-" + value}
                    >
                      {value}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
